import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './WorkOrderSerialNumber.redux';
import { Button } from 'antd';
import { teamMemberCheck } from '@/pages/WorkOrder/WorkOrderHelperMethods';
import { useParams } from 'react-router-dom';
import WorkOrderSNAllocationModal from './WorkOrderSNAllocationModal';

const WorkOrderSNAllocationButton = () => {
	const dispatch             = useDispatch(),
		  params               = useParams(),
		  docNum               = params.docNum,
		  loggedEmpId          = useSelector(state => state.workOrderReference.loggedEmpId),
		  teamsList            = useSelector(state => state.workOrderReference.teamsList),
		  showAllocationButton = useSelector(state => state.workOrderSerialNum.showAllocationButton);
	
	// useEffect(() => {
	// 	if (docNum) {
	// 		dispatch(actions.workOrderSNAllocationCheck(docNum));
	// 	}
	// }, [ dispatch, docNum ]);

    return (
		<>
			{ showAllocationButton && 
			<>
				<Button
					disabled={!teamMemberCheck(teamsList, loggedEmpId, 'T3')} // code 3 is 'Planning' team
					size="large"
					type="primary"
					onClick={() => {
						dispatch(actions.setState({ SNAllocationModalOpen: true }));
					}}
				>
					Allocate Serial Numbers
				</Button>

				<WorkOrderSNAllocationModal />
			</>
			}
		</>
                
    );
};

export default WorkOrderSNAllocationButton;
